module.exports = __webpack_public_path__ + "img/bus_title_img_8.2c79b9a1.png";